module.exports = __webpack_public_path__ + "static/media/pinme2.cb5dda03.gif";